@if(isStandardGroup(group)) {
  @if(isSelectedPeople()) {
    <label class="people-count"></label>
  }
  @else if(isDefaultValues()){
    <div class="grid pl-2 mt-2">
        <label
            class="w-full mt-0 uppercase text-lg font-semibold mb-4">{{cs.getLabelValue(moduleName+'.groups.'+group.code+'.label',attributeLabels,group.code)}}</label>
        <div class="mt-2 w-full bottom-border">
            <div class="grid text-sm font-semibold mb-2">
                <div class="col-6 pb-0 pr-0">
                    <label class="flex mb-0 font-semibold text-base" translate>settings.lbl_order_general_settings</label>
                </div>
                <div class="col-6 pb-0 pr-0 pl-0">
                    <label class="flex mb-0 font-semibold text-base action-label" translate>settings.lbl_order_general_settings_action</label>
                </div>
            </div>
        </div>
    </div> 
  } 
  @else if( isUserProfile() ) {
      <div class="grid pl-2 mt-2">
        <label
            class="w-full mt-0 uppercase font-semibold user-profile mb-3">{{cs.getLabelValue(moduleName+'.groups.'+group.code+'.label',attributeLabels,group.code)}}</label>
      </div>
  }
  @else if(isNotification()){
    <div class="grid pl-2 mt-2">
        <label
            class="w-full mt-0 uppercase text-lg font-semibold">{{cs.getLabelValue(moduleName+'.groups.'+group.code+'.label',attributeLabels,group.code)}}</label>
        <div class="mt-4 w-full bottom-border">
            <div class="grid text-sm font-semibold mb-2">
                <div class="col-6 pb-0 pr-0">
                    <label class="flex mb-0 font-semibold text-base" translate>settings.lbl_order_general_settings</label>
                </div>
                <div class="col-6 pb-0 pr-0 pl-0">
                    <label class="flex mb-0 font-semibold text-base action-label" translate>settings.lbl_order_general_settings_action</label>
                </div>
            </div>
        </div>
    </div> 
  }
  @else {
    @if(moduleName === AppSettings.ENTITY_CODE.SITE_DELIVERY_ADDRESS) {
    }
    @else {
      <label class="w-full mt-0 uppercase text-lg font-semibold">{{cs.getLabelValue(moduleName+'.groups.'+group.code+'.label',attributeLabels,group.code)}}</label>
    }
  } 
}

@if(isDownloadAccountData()) {
  <label class="note-text block w-full mt-2" translate>lbl_text_for_download_data</label>
  <div class="mt-3 mb-2 pb-2 note-div align-content-center">
    <div class="p-2">
      <img class="note-img" src="../../../../../assets/images/mi-theme/light/basic/error_outline.svg">
    </div>
    <div class="align-content-center">
      <label class="text-sm opacity-70" translate>lbl_note_for_download_date</label>
    </div>
  </div>
}

@if(isPasswordRequirements()) {
  <br>
  <div class="mt-2">
    <label class="note-text w-full " translate>lbl_text_for_password_requirement</label>
  </div>
  <div class="mt-3 flex mb-2 note2-div align-content-center">
    <div class="p-2">
      <img class="note-img" src="../../../../../assets/images/mi-theme/light/basic/error_outline.svg">
    </div>
    <div class="align-content-center">
      <label class="text-sm opacity-70" translate>lbl_note_for_password_requirement</label>
    </div>
  </div>
}

@if(isSessionTimeout()) {
<br><br>
  <label class="note-text w-full mt-3" translate>lbl_text_for_session_timeout</label>
} 
